import React, { FC, useState } from 'react';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';
import Button from 'shared/components/andtComponents/Button';
import { ResourceData } from '../../types';
import BulkDeleteConfirmationModal from './BulkDeleteConfirmationModal';
import styles from './GovernanceTagsBulkOperations.module.scss';

interface GovernanceTagsBulkOperationsProps {
  selectedResources: ResourceData[];
  onAddGovernanceTag: (resources: ResourceData[]) => void;
  onRemoveGovernanceTag: (resources: ResourceData[]) => Promise<void>;
}

const GovernanceTagsBulkOperations: FC<GovernanceTagsBulkOperationsProps> = ({
  selectedResources,
  onAddGovernanceTag,
  onRemoveGovernanceTag,
}) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleAddGovernanceTag = () => {
    onAddGovernanceTag(selectedResources);
  };

  const handleRemoveGovernanceTag = () => {
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    setIsDeleting(true);
    try {
      await onRemoveGovernanceTag(selectedResources);
      setIsDeleteModalOpen(false);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleCloseDeleteModal = () => {
    if (!isDeleting) {
      setIsDeleteModalOpen(false);
    }
  };

  return (
    <>
      <div className={styles.container}>
        <Button
          className={{ buttonContent: styles.subContainer }}
          icon={() => <GenerateIcon iconName={ICONS.delete.name} className={styles.icon} />}
          isTextButton
          onClick={handleRemoveGovernanceTag}
          text="Remove Virtual Tag"
          automationid="remove-governance-tag-bulk"
        />
        <Button
          className={{ buttonContent: styles.subContainer }}
          icon={() => <GenerateIcon iconName={ICONS.circlePlus.name} className={styles.icon} />}
          isTextButton
          onClick={handleAddGovernanceTag}
          text="Add Virtual Tag"
          automationid="add-governance-tag-bulk"
        />
      </div>

      <BulkDeleteConfirmationModal
        isOpen={isDeleteModalOpen}
        selectedResources={selectedResources}
        isLoading={isDeleting}
        onClose={handleCloseDeleteModal}
        onConfirm={handleConfirmDelete}
      />
    </>
  );
};

export default GovernanceTagsBulkOperations;
